/* Castor Hub UK — product page (ch-product) */
(function () {
  var root = document.querySelector('[data-chp]');
  if (!root) return;
  var dataEl = document.querySelector('[data-chp-json]');
  var P = {};
  try { P = JSON.parse(dataEl.textContent); } catch (e) { P = { variants: [] }; }
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var form = document.getElementById('chp-form');
  var idInput = $('[data-chp-id]');
  var current = P.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || P.variants[0];

  /* ---------- gallery + lightbox ---------- */
  var slides = $$('[data-chp-slide]');
  var thumbs = $$('[data-chp-thumb]');
  var cur = 0;
  function show(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.hidden = k !== cur; s.classList.toggle('is-on', k === cur); });
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.chpThumb); }); });
  var lb;
  function openLb() {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'chp-lb'; lb.hidden = true;
      lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product photos');
      lb.innerHTML = '<img alt=""><button type="button" class="chp-lb__x" aria-label="Close">×</button>' +
        (slides.length > 1 ? '<button type="button" class="chp-lb__p" aria-label="Previous photo">‹</button><button type="button" class="chp-lb__n" aria-label="Next photo">›</button>' : '') +
        '<p class="chp-lb__c"></p>';
      root.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('chp-lb__x')) closeLb();
        else if (e.target.classList.contains('chp-lb__p')) { show(cur - 1); paintLb(); }
        else if (e.target.classList.contains('chp-lb__n')) { show(cur + 1); paintLb(); }
      });
      document.addEventListener('keydown', function (e) {
        if (!lb || lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') { show(cur - 1); paintLb(); }
        if (e.key === 'ArrowRight') { show(cur + 1); paintLb(); }
      });
    }
    paintLb(); lb.hidden = false; document.documentElement.style.overflow = 'hidden';
    lb.querySelector('.chp-lb__x').focus();
  }
  function paintLb() {
    var img = slides[cur].querySelector('img');
    var big = img.currentSrc || img.src;
    big = big.replace(/([?&])width=\d+/, '$1width=1800');
    lb.querySelector('img').src = big;
    lb.querySelector('img').alt = img.alt || '';
    lb.querySelector('.chp-lb__c').textContent = 'Photo ' + (cur + 1) + ' of ' + slides.length;
  }
  function closeLb() { lb.hidden = true; document.documentElement.style.overflow = ''; slides[cur].focus(); }
  slides.forEach(function (s) { s.addEventListener('click', openLb); });

  /* ---------- variants ---------- */
  var selects = $$('[data-chp-opt]');
  function selectedOptions() {
    var opts = current.options.slice();
    selects.forEach(function (s) { opts[+s.dataset.chpOpt] = s.value; });
    return opts;
  }
  function findVariant(opts) {
    return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
  }
  function markSoldOut() {
    var opts = selectedOptions();
    selects.forEach(function (s) {
      var idx = +s.dataset.chpOpt;
      Array.prototype.forEach.call(s.options, function (o) {
        var test = opts.slice(); test[idx] = o.value;
        var v = findVariant(test);
        var ok = v && v.available;
        o.textContent = o.value + (v ? (ok ? '' : ' (sold out)') : ' (unavailable)');
      });
    });
  }
  function setVariant(v) {
    if (!v) {
      $('[data-chp-add-t]').textContent = 'Unavailable';
      $('[data-chp-add]').disabled = true; $('[data-chp-now]').disabled = true;
      return;
    }
    current = v;
    idInput.value = v.id;
    $('[data-chp-price]').textContent = v.price;
    var st = $('[data-chp-stock]');
    st.textContent = v.available ? 'In stock' : 'Out of stock';
    st.classList.toggle('is-out', !v.available);
    var sku = $('[data-chp-sku]');
    if (v.sku) { sku.hidden = false; $('[data-chp-sku-v]').textContent = v.sku; } else sku.hidden = true;
    $('[data-chp-add-t]').textContent = v.available ? 'Add to basket' : 'Sold out';
    $('[data-chp-add]').disabled = !v.available; $('[data-chp-now]').disabled = !v.available;
    if (v.media) {
      var k = slides.findIndex ? slides.findIndex(function (s) { return s.dataset.mediaId === String(v.media); }) : -1;
      if (k > -1) show(k);
    }
    try {
      var u = new URL(location.href); u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    } catch (e) {}
    markSoldOut();
    drawing();
  }
  selects.forEach(function (s) { s.addEventListener('change', function () { setVariant(findVariant(selectedOptions())); }); });
  if (selects.length) markSoldOut();

  /* ---------- quantity + add ---------- */
  var qty = $('[data-chp-qty]');
  $$('[data-chp-step]').forEach(function (b) {
    b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + +b.dataset.chpStep); });
  });
  var msg = $('[data-chp-msg]');
  function say(t, err, html) { msg.hidden = false; msg.classList.toggle('is-err', !!err); if (html) msg.innerHTML = t; else msg.textContent = t; }
  function addToCart(id, q) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: q }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket'); return j; }); });
  }
  function cartUpdated() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('ch:cart-updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ch-product', data: { itemCount: cart.item_count } } }));
      return cart;
    }).catch(function () {});
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = $('[data-chp-add]');
    if (btn.disabled) return;
    btn.classList.add('is-busy'); btn.disabled = true;
    addToCart(current.id, Math.max(1, parseInt(qty.value, 10) || 1)).then(function () {
      say('Added to basket — <a href="/cart">View basket</a>', false, true);
      return cartUpdated();
    }).catch(function (err) { say(err.message, true); })
      .then(function () { btn.classList.remove('is-busy'); btn.disabled = !current.available; });
  });
  $('[data-chp-now]').addEventListener('click', function () {
    var b = this; b.disabled = true;
    addToCart(current.id, Math.max(1, parseInt(qty.value, 10) || 1)).then(function () { location.href = '/checkout'; })
      .catch(function (err) { say(err.message, true); b.disabled = false; });
  });

  /* ---------- description: short → Specifications → Key features → rest ---------- */
  var desc = $('[data-chp-desc]');
  var heads = desc ? $$('h1,h2,h3,h4', desc).filter(function (h) { return h.parentNode === desc; }) : [];
  var secs = [];
  if (desc && heads.length) {
    var intro = [], node = desc.firstChild, curSec = null;
    while (node) {
      if (node.nodeType === 1 && heads.indexOf(node) > -1) { curSec = { h: node, nodes: [node] }; secs.push(curSec); }
      else if (curSec) curSec.nodes.push(node); else intro.push(node);
      node = node.nextSibling;
    }
    var rank = function (s) { var t = s.h.textContent.toLowerCase(); return /spec/.test(t) ? 0 : /feature/.test(t) ? 1 : 2; };
    var ordered = secs.slice().sort(function (a, b) { return rank(a) - rank(b) || secs.indexOf(a) - secs.indexOf(b); });
    ordered.forEach(function (s) { s.nodes.forEach(function (n) { desc.appendChild(n); }); });
    secs = ordered;
    secs.forEach(function (s) {
      var t = s.h.textContent.toLowerCase();
      var list = s.nodes.filter(function (n) { return n.nodeType === 1 && n.tagName === 'UL'; })[0];
      if (!list) return;
      var lis = $$('li', list);
      var withColon = lis.filter(function (li) { return /:/.test(li.textContent); }).length;
      if (/spec|dimension|technical/.test(t) && lis.length && withColon / lis.length >= 0.6) {
        var tbl = document.createElement('table'), tb = document.createElement('tbody');
        lis.forEach(function (li) {
          var txt = li.textContent; var i = txt.indexOf(':');
          var tr = document.createElement('tr'), td = document.createElement('td');
          if (i > 0) {
            var th = document.createElement('th');
            th.scope = 'row'; th.textContent = txt.slice(0, i).trim(); td.textContent = txt.slice(i + 1).trim();
            tr.appendChild(th);
          } else { td.colSpan = 2; td.textContent = txt.trim(); }
          tr.appendChild(td); tb.appendChild(tr);
        });
        tbl.appendChild(tb); list.parentNode.replaceChild(tbl, list);
      } else if (/feature|benefit/.test(t)) list.classList.add('chp-feats');
      else if (/application|use|suitable|ideal/.test(t)) list.classList.add('chp-chips');
    });
  }

  /* ---------- technical drawing (only from real values) ---------- */
  function num(re, s) { var m = s.match(re); return m ? m : null; }
  function drawing() {
    var box = $('[data-chp-draw]'); if (!box) return;
    var text = [P.title, current && current.title, desc ? desc.textContent : ''].join(' \n ');
    var d = {};
    var m;
    if ((m = num(/wheel\s*dia(?:meter)?\.?\s*:?\s*(\d{2,3})\s*mm/i, text)) || (m = num(/^(\d{2,3})\s*mm\b/i, P.title))) d.dia = m[1];
    if ((m = num(/tread\s*width\s*:?\s*([\d\/]+)\s*mm/i, text))) d.tread = m[1];
    if ((m = num(/overall\s*height\s*:?\s*(\d{2,3})\s*mm/i, text))) d.h = m[1];
    if ((m = num(/top\s*plate\s*:?\s*(\d{2,3})\s*(?:mm)?\s*[x×]\s*(\d{2,3})\s*mm/i, text)) || (m = num(/plate\s*(?:dimensions|size)\s*:?\s*(\d{2,3})\s*[x×]\s*(\d{2,3})\s*mm/i, text))) d.plate = m[1] + ' × ' + m[2];
    if ((m = num(/hole\s*centres\s*:?\s*(\d{2,3})\s*(?:mm)?\s*[x×]\s*(\d{2,3})\s*mm/i, text)) || (m = num(/(\d{2,3})\s*[x×]\s*(\d{2,3})\s*mm\s*(?:hole\s*)?centres/i, text))) d.holes = m[1] + ' × ' + m[2];
    if ((m = num(/bolt\s*hole\s*:?\s*(M?\d{1,2}(?:\s*mm)?)/i, text))) d.bolt = m[1].replace(/\s*mm/i, 'mm');
    if ((m = num(/\bbore\s*:?\s*(\d{1,2})\s*mm/i, text))) d.bore = m[1];
    if ((m = num(/hub\s*length\s*:?\s*(\d{2,3})\s*mm/i, text))) d.hub = m[1];
    if ((m = num(/load(?:\s*capacity)?\s*:?\s*([\d,]{2,5})\s*kg/i, text)) || (m = num(/([\d,]{2,5})\s*kg/i, P.title))) d.load = m[1];
    var isWheel = /wheel only/i.test(current && current.title || '') || (root.dataset.dept === 'wheels' && !/complete castor/i.test(current && current.title || ''));
    var isBolt = /bolt\s*hole/i.test(text) && !d.plate;
    var rows = [];
    var svg = '';
    var dimLine = function (x1, y1, x2, y2, lx, ly, l) {
      return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="#136F99" stroke-width="1.6"/>' +
        '<text x="' + lx + '" y="' + ly + '" fill="#136F99" font-size="13" font-weight="700" font-family="IBM Plex Mono,monospace" text-anchor="middle">' + l + '</text>';
    };
    if (isWheel && d.dia) {
      if (d.dia) rows.push(['A', 'Wheel diameter', d.dia + 'mm']);
      if (d.tread) rows.push(['B', 'Tread width', d.tread + 'mm']);
      if (d.bore) rows.push(['C', 'Bore', d.bore + 'mm']);
      if (d.hub) rows.push(['D', 'Hub length', d.hub + 'mm']);
      svg = '<svg viewBox="0 0 260 200" role="img" aria-label="Wheel dimensions">' +
        '<circle cx="110" cy="100" r="70" fill="none" stroke="#0F1A24" stroke-width="2.4"/><circle cx="110" cy="100" r="44" fill="none" stroke="#0F1A24" stroke-width="1.4"/>' +
        '<circle cx="110" cy="100" r="12" fill="none" stroke="#0F1A24" stroke-width="2"/>' +
        dimLine(40, 186, 180, 186, 110, 182 - 6, 'A') +
        (d.bore ? dimLine(98, 100, 122, 100, 110, 94, 'C') : '') +
        (d.tread ? '<rect x="206" y="30" width="26" height="140" rx="6" fill="none" stroke="#0F1A24" stroke-width="2.2"/>' + dimLine(206, 186, 232, 186, 219, 180, 'B') : '') + '</svg>';
    } else if (!isWheel && (d.h || d.plate || d.bolt) && d.dia) {
      if (isBolt && d.bolt) rows.push(['A', 'Bolt hole', d.bolt]);
      if (d.plate) rows.push(['A', 'Top plate size', d.plate + 'mm']);
      if (d.h) rows.push(['B', 'Overall height', d.h + 'mm']);
      rows.push(['C', 'Wheel diameter', d.dia + 'mm']);
      if (d.holes) rows.push(['', 'Hole centres', d.holes + 'mm']);
      if (d.tread) rows.push(['', 'Tread width', d.tread + 'mm']);
      var top = isBolt ? '<line x1="140" y1="18" x2="140" y2="48" stroke="#0F1A24" stroke-width="4"/><rect x="128" y="44" width="24" height="10" fill="none" stroke="#0F1A24" stroke-width="2"/>'
        : '<rect x="86" y="34" width="108" height="12" fill="none" stroke="#0F1A24" stroke-width="2.2"/>';
      svg = '<svg viewBox="0 0 280 250" role="img" aria-label="Castor dimensions">' + top +
        '<path d="M116 54 L164 54 L158 120 L122 120 Z" fill="none" stroke="#0F1A24" stroke-width="2"/>' +
        '<circle cx="140" cy="168" r="58" fill="none" stroke="#0F1A24" stroke-width="2.4"/><circle cx="140" cy="168" r="16" fill="none" stroke="#0F1A24" stroke-width="1.6"/>' +
        '<line x1="76" y1="168" x2="204" y2="168" stroke="#136F99" stroke-dasharray="4 4"/>' +
        (isBolt ? '' : dimLine(86, 22, 194, 22, 140, 16, 'A')) +
        (d.h ? dimLine(52, 34, 52, 226, 40, 134, 'B') : '') +
        dimLine(228, 110, 228, 226, 244, 172, 'C') + '</svg>';
    } else if (d.dia && (d.load || d.tread)) {
      rows.push(['', 'Diameter', d.dia + 'mm']);
      if (d.tread) rows.push(['', 'Tread width', d.tread + 'mm']);
    }
    if (d.load && rows.length) rows.push(['', 'Load capacity', d.load.replace(/,/g, '') + 'kg']);
    if (!rows.length) { box.hidden = true; return; }
    $('[data-chp-svg]').innerHTML = svg;
    $('[data-chp-svg]').hidden = !svg;
    $('[data-chp-dims]').innerHTML = rows.map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd><dd class="v">' + r[2] + '</dd>'; }).join('');
    box.hidden = false;
    var fx = $('[data-chp-fixed-link]');
    if (fx && d.dia) { fx.href = '/search?type=product&q=' + encodeURIComponent(d.dia + 'mm fixed castor'); fx.textContent = 'See ' + d.dia + 'mm fixed castors →'; }
    root.dataset.dia = d.dia || ''; root.dataset.load = d.load || '';
  }
  drawing();

  /* ---------- complete the set (collapsed, after the description) ---------- */
  var set = $('[data-chp-set]');
  function movement(t) { t = t.toLowerCase(); if (/twin/.test(t)) return 'twin'; if (/fixed/.test(t)) return 'fixed'; if (/brake/.test(t)) return 'braked'; if (/swivel/.test(t)) return 'swivel'; if (/wheel only|wheel/.test(t)) return 'wheel'; return ''; }
  function material(t) { t = t.toLowerCase(); var ms = ['anti-static', 'polyurethane', 'rubber', 'nylon', 'cast iron', 'stainless', 'puncture', 'high temp', 'thermoplastic']; for (var i = 0; i < ms.length; i++) if (t.indexOf(ms[i]) > -1) return ms[i]; return ''; }
  function mount(t) { t = t.toLowerCase(); return /bolt[\s-]*hole/.test(t) ? 'bolt' : /plate/.test(t) ? 'plate' : ''; }
  var label = { fixed: 'Fixed', swivel: 'Swivel · no brake', braked: 'Braked swivel', twin: 'Twin wheel', wheel: 'Wheel only' };
  function money(p) { var n = typeof p === 'string' ? parseFloat(p) : p / 100; if (typeof p === 'string' && p.indexOf('.') < 0) n = parseFloat(p) / 100; return '£' + n.toFixed(2); }
  function card(p, eyebrow) {
    var v = p.variants || [];
    var single = v.length === 1;
    var img = p.featured_image && p.featured_image.url || p.image || '';
    if (img && img.indexOf('width=') < 0) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
    return '<div class="chp-c"><a class="chp-c__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="chp-c__b">' + (eyebrow ? '<span class="chp-c__k">' + eyebrow + '</span>' : '') +
      '<a class="chp-c__t" href="' + p.url + '">' + p.title.replace(/</g, '&lt;') + '</a>' +
      '<div class="chp-c__f"><span class="chp-c__p">' + money(p.price) + '</span>' +
      (single && v[0].available !== false ? '<button type="button" class="chp-c__btn" data-chp-add-id="' + v[0].id + '">Add</button>' : '<a class="chp-c__btn" href="' + p.url + '">Choose</a>') +
      '</div></div></div>';
  }
  function showSet(items, sub, allUrl, allText) {
    if (!items.length) return;
    $('[data-chp-set-grid]').innerHTML = items.join('');
    $('[data-chp-set-sub]').textContent = sub;
    var a = $('[data-chp-set-all]');
    if (allUrl) { a.href = allUrl; a.textContent = allText; a.hidden = false; }
    set.hidden = false;
    var tab = $('[data-chp-tab-set]'); if (tab) tab.hidden = false;
  }
  function loadSet() {
    var dia = root.dataset.dia, mat = material(P.title), mv = movement(P.title + ' ' + (current.title || '')), mt = mount(P.title + ' ' + (current.title || ''));
    if (dia && (root.dataset.dept === 'castors' || root.dataset.dept === 'wheels')) {
      var q = dia + 'mm ' + (mat || 'castor');
      var mw = mt === 'bolt' ? ' bolt hole' : mt === 'plate' ? ' plate' : '';
      var qs = mv === 'wheel' ? [q] : ['fixed', 'swivel', 'braked swivel'].filter(function (w) { return movement(w) !== mv; })
        .map(function (w) { return dia + 'mm ' + w + mw + ' ' + (mat || 'castor'); }).concat([q]);
      var sugg = function (term) {
        return fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide')
          .then(function (r) { return r.json(); }).then(function (j) { return (j.resources && j.resources.results && j.resources.results.products) || []; }).catch(function () { return []; });
      };
      Promise.all(qs.map(sugg)).then(function (lists) {
        var seen = {}, ps = [];
        lists.forEach(function (l) { l.forEach(function (p) { if (!seen[p.handle]) { seen[p.handle] = 1; ps.push(p); } }); });
        var scored = ps.filter(function (p) { return p.handle !== root.dataset.handle && new RegExp('\\b' + dia + '\\s*mm', 'i').test(p.title); })
          .map(function (p) {
            var s = 0, pm = movement(p.title);
            if (pm && pm !== mv) s += 3;
            if (mat && material(p.title) === mat) s += 2;
            if (mt && mount(p.title) === mt) s += 2;
            if (root.dataset.load && p.title.indexOf(root.dataset.load + 'kg') > -1) s += 1;
            if (pm === mv && material(p.title) === mat) s -= 2;
            return { p: p, s: s, m: pm };
          }).sort(function (a, b) { return b.s - a.s; });
        var pick = [], used = {};
        scored.forEach(function (x) { if (pick.length < 3 && !used[x.m]) { used[x.m] = 1; pick.push(x); } });
        scored.forEach(function (x) { if (pick.length < 3 && pick.indexOf(x) < 0) pick.push(x); });
        if (!pick.length) return fallback();
        return Promise.all(pick.map(function (x) {
          return fetch('/products/' + x.p.handle + '.js').then(function (r) { return r.json(); })
            .then(function (full) { x.p.variants = (full.variants || []).map(function (v) { return { id: v.id, available: v.available }; }); return x; })
            .catch(function () { return x; });
        })).then(function (pk) {
          showSet(pk.map(function (x) { return card(x.p, label[x.m] || ''); }),
            'Same ' + dia + 'mm ' + (mat ? mat + ' ' : '') + 'range — mix swivel, braked and fixed so your trolley sits level.',
            '/search?type=product&q=' + encodeURIComponent(q), 'View all ' + dia + 'mm ' + (mat || '') + ' results →');
        });
      }).catch(fallback);
    } else fallback();
  }
  function fallback() {
    var pid = root.dataset.productId;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=complementary')
      .then(function (r) { return r.json(); }).then(function (j) {
        var ps = j.products || [];
        if (ps.length) return ps;
        return fetch('/recommendations/products.json?product_id=' + pid + '&limit=3&intent=related').then(function (r) { return r.json(); }).then(function (k) { return k.products || []; });
      }).then(function (ps) {
        ps = ps.slice(0, 3).map(function (p) {
          return { url: p.url, title: p.title, price: p.price, featured_image: { url: p.featured_image || (p.images && p.images[0]) }, variants: (p.variants || []).map(function (v) { return { id: v.id, available: v.available }; }) };
        });
        showSet(ps.map(function (p) { return card(p, ''); }), 'Items often fitted alongside this one.');
      }).catch(function () {});
  }
  if (set) {
    if ('requestIdleCallback' in window) requestIdleCallback(loadSet, { timeout: 2000 }); else setTimeout(loadSet, 600);
    set.addEventListener('click', function (e) {
      var b = e.target.closest('[data-chp-add-id]'); if (!b) return;
      b.disabled = true; b.textContent = 'Adding…';
      addToCart(+b.dataset.chpAddId, 1).then(function () { b.textContent = 'Added ✓'; return cartUpdated(); })
        .catch(function () { b.textContent = 'Try again'; b.disabled = false; });
    });
    var sd = $('[data-chp-set-d]'), tog = $('.chp-set__tog');
    if (sd && tog) sd.addEventListener('toggle', function () { tog.firstChild.nodeValue = sd.open ? 'Hide ' : 'Show '; });
    var tabSet = $('[data-chp-tab-set]');
    if (tabSet) tabSet.addEventListener('click', function () { $('[data-chp-set-d]').open = true; });
  }

  /* ---------- tabs highlight ---------- */
  var tabs = $$('[data-chp-tabs] a');
  if ('IntersectionObserver' in window && tabs.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        tabs.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    tabs.forEach(function (a) { var t = document.querySelector(a.getAttribute('href')); if (t) io.observe(t); });
  }
})();
